import { SliderDataAttrs } from "../slider/data.js";
//#region src/core/ui/time-slider/data.ts
/** @internal */
const TimeSliderDataAttrs = {
	...SliderDataAttrs,
	/** Present when a seek operation is in progress. */
	seeking: "data-seeking"
};
//#endregion
export { TimeSliderDataAttrs };
